/**
 * File validation constants and configurations
 */

export const FILE_VALIDATION_CONSTANTS = {
  DEFAULT_ALLOWED_TYPES: 'jpg,jpeg,bmp,png,gif,mp4,mkv,avi,mpeg,mov,webm,mpg,mp2,mpe,mpv,ogg,m4v,mp3,m4a,aac,oga,webp,svg,doc,docx,pdf,csv,txt,xls,xlxs,xlsm,xlsx',
  DEFAULT_MAX_FILE_SIZE: 4194304, // 4MB in bytes

  CSS_CLASSES: {
    DRAG_VALID: 'drag-valid',
    DRAG_INVALID: 'drag-invalid',
    DRAG_MIXED: 'drag-mixed'
  },

  COLORS: {
    VALID: {
      BORDER: 'var(--mom-primary)',
      BACKGROUND: '#EDEDFCB2'
    },
    INVALID: {
      BORDER: 'var(--rag-red)',
      BACKGROUND: '#FFE6E6B2'
    },
    MIXED: {
      BORDER: 'var(--rag-amber)',
      BACKGROUND: '#FFF4E6B2'
    }
  },

  DRAG_MESSAGES: {
    UNSUPPORTED_FILE_TYPE: 'common.this_file_format_is_not_supported',
    UPLOAD_SINGLE_FILE: 'common.upload_a_single_file',
    SOME_FILES_WILL_BE_SKIPPED: 'common.some_items_are_not_supported_and_will_be_skipped',
    DRAG_OR_PASTE_FILES_HERE: 'common.drag_or_paste_files_here_to_upload',
    FILE_TOO_LARGE: 'common.the_file_is_too_large_try_smaller',
    FILE_NOT_SUPPORTED: 'common.the_file_is_not_supported_try_different_type'
  },

  TRANSLATION_KEYS: {
    UNSUPPORTED_FILE_TYPE: 'common.unsupported_file_type',
    UPLOAD_SINGLE_FILE: 'common.you_can_only_upload_1_file_at_time',
    SOME_FILES_WILL_BE_SKIPPED: 'common.error_imageWrongExt',
    DRAG_OR_PASTE_FILES_HERE: 'common.drag_or_paste_files_here_to_upload',
    FILE_TOO_LARGE: 'common.the_file_is_too_large_try_smaller',
    FILE_NOT_SUPPORTED: 'common.the_file_is_not_supported_try_different_type'
  }
} as const;

/**
 * MIME type to file extension mappings for drag validation
 * Only includes supported file types that should be allowed
 */
export const MIME_TYPE_MAPPINGS = {
  // Images
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
  'image/tiff': 'tiff',

  // Documents
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'text/plain': 'txt',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'text/csv': 'csv',

  // Videos
  'video/mp4': 'mp4',
  'video/avi': 'avi',
  'video/quicktime': 'mov',
  'video/x-msvideo': 'avi',

  // Audio
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'audio/ogg': 'ogg',

  // Archives (if supported by configuration)
  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',
  'application/x-rar-compressed': 'rar',
  'application/x-7z-compressed': '7z'
} as const;
